'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.UNAUTHORISED = exports.REFRESH_AUTH_TOKEN_SUCCESS = exports.REFRESH_AUTH_TOKEN = undefined;
exports.unauthorised = unauthorised;
exports.refreshAuthToken = refreshAuthToken;
exports.refreshAuthTokenSuccess = refreshAuthTokenSuccess;

var _daoConfiguration = require('../configuration/daoConfiguration');

var REFRESH_AUTH_TOKEN = exports.REFRESH_AUTH_TOKEN = 'REFRESH_AUTH_TOKEN';
var REFRESH_AUTH_TOKEN_SUCCESS = exports.REFRESH_AUTH_TOKEN_SUCCESS = 'REFRESH_AUTH_TOKEN_SUCCESS';
var UNAUTHORISED = exports.UNAUTHORISED = 'UNAUTHORISED';

function unauthorised() {
	(0, _daoConfiguration.getDaoAnalytics)().setUserId(undefined);
	return {
		type: UNAUTHORISED
	};
}

function refreshAuthToken() {
	return {
		type: REFRESH_AUTH_TOKEN
	};
}

function refreshAuthTokenSuccess(token) {
	return {
		type: REFRESH_AUTH_TOKEN_SUCCESS,
		authToken: token.authToken,
		refreshToken: token.refreshTokenId
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fetch/dist/action/daoActions.js
 ** module id = 644
 ** module chunks = 0
 **/